
import {Reducer} from 'redux';
import * as Types from './types';
import * as Actions from './actions';

//Actions.Actions is not striclty accurate as I just discovered that redux send an action 
//"@@redux/INIT" during createStore
const reducer: Reducer<Types.State> = (state: Types.State,action: Actions.Actions) => {
	switch(state.loadingStep) {
		case Types.LoadingStep.NotLoaded:
			return notLoadedStateReducer(state,action);
		case Types.LoadingStep.Loading:
			return loadingStateReducer(state,action);
		case Types.LoadingStep.LoadError:
			return state;
		case Types.LoadingStep.Loaded:
			return loadedStateReducer(state,action);
	}
} ;

const notLoadedStateReducer: Reducer<Types.State> = (state: Types.NotLoadedState,action: Actions.Actions) => {
	switch(action.type) {
		case 'FETCH_ROW_REQUEST':
			return {...state,loadingStep: Types.LoadingStep.Loading, b_o: action.payload.b_o, token: action.payload.token, isNewRow: false};
		case 'FETCH_NEW_ROW_REQUEST':
			return {...state,loadingStep: Types.LoadingStep.Loading, b_o: action.payload.b_o, token: action.payload.token, isNewRow: true};
		case 'FETCH_ROW_FAILURE':
		case 'FETCH_ROW_SUCCESS':
		default: 
			return state;
	}
} ;

const loadingStateReducer: Reducer<Types.State> = (state: Types.LoadingState,action: Actions.Actions) => {
	switch(action.type) {
		case 'FETCH_ROW_FAILURE':
		case 'FETCH_NEW_ROW_FAILURE':
			return {...state,
				loadingStep: Types.LoadingStep.LoadError,
				error: formatFailureResponse(action.payload) 
			};
		case 'FETCH_ROW_SUCCESS':
		case 'FETCH_NEW_ROW_SUCCESS':
			const tableRow = action.type==='FETCH_NEW_ROW_SUCCESS' ? 
					completeDefaultValues(action.payload.fields, action.payload.tableRow ) : 
					action.payload.tableRow;
			const tableRowCopy = JSON.parse(JSON.stringify(tableRow)) ; 
			return {...state,
				loadingStep: Types.LoadingStep.Loaded,
				fields: action.payload.fields,
				originalTableRow: tableRow,
				tableRow: tableRowCopy,
				tableName: action.payload.tableName,
				cssUid: action.payload.cssUid
			};
		case 'FETCH_ROW_REQUEST':
		default: 
			return state;
	}
} ;



function completeDefaultValues(fields: Array<Types.Field> ,defaultValues: Types.TableRow) : Types.TableRow {
	const tableRow = {}; 
	fields.forEach(function(field) {
		tableRow[field.id] = defaultValues[field.id] === undefined ? null : defaultValues[field.id];
	});
	return tableRow;
};


const loadedStateReducer: Reducer<Types.State> = (state: Types.LoadedState,action: Actions.Actions) => {
	switch(action.type) {
		case 'CHANGE_FIELD_VALUE':
			return {...state,
				tableRow: {...state.tableRow,[action.payload.fieldId]: action.payload.value}
			};
		case 'SAVE_REQUEST':
			return {...state,
				saveResult: "pending"
			};
		case 'SAVE_SUCCESS':
			return {...state,
				tableRow: Object.assign({},state.tableRow, action.payload.response.tableRow || {}),
				originalTableRow: Object.assign({},state.tableRow, action.payload.changes,action.payload.response.tableRow || {}),
				saveResult: {
					status: 'ok',
					ack: false
				}
			};
		case 'SAVE_FAILURE':
			return {...state,
				saveResult: {
					status: formatFailureResponse(action.payload),
					ack: false
				}
			};
		case 'ACK_SAVE_RESULT':
			if(state.saveResult==="pending") {
				return state; //cannot happen
			}
			return {...state,
				saveResult: {
					...state.saveResult!,
					ack: true
				}
			};
		default: 
			return state;
	}
} ;

function formatFailureResponse(response: Actions.FailureResponse) : string {
	if(typeof response === "string") {
		return response;
	}
	return formatFailureApiResponse(response as Actions.FailureApiResponse); 
}

function formatFailureApiResponse(response: Actions.FailureApiResponse): string {
	return response.errorMsg ? 
		response.errorCode + ": " + response.errorMsg :
		response.errorCode;
}

export default reducer;








// WEBPACK FOOTER //
// ./src/store/reducers.ts